<section>
    <div class="container">
        <candidates-list [candidates]="candidates" [totalPageCount]="totalPageCount"></candidates-list>
        <div class="row">
          <pager [totalPageCount]="totalPageCount" (valueChange)="onPagerValueChanged($event)"></pager>
        </div>
    </div>
  </section>